import cookie from 'js-cookie';

export const getVisitedPsychicsIds = () => {
  const psychicsIds = decodeURI(cookie.get('extIds') || '');

  if (!psychicsIds) {
    return;
  }

  const idsArray = JSON.parse(psychicsIds);

  if (!Array.isArray(idsArray)) {
    return;
  }

  return idsArray.join(',');
};
